import { ApiFilterConfig } from 'src/app/rokezzz/api/api/api-filter-config';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RokezzzApiService } from '../../api/services/api.service';
import { OnFinish } from '../../api/api/on-finish';
import { ApiResponse } from '../../api/api/api-response';
import { Setting } from '../api/setting';

@Injectable({
    providedIn: 'root'
})
export class RokezzzSettingService {
    public readonly apiPath: string = 'settings';

    public constructor(
        protected readonly rokezzzApiService: RokezzzApiService,
    ) { }

    public getIRI(id: number): string {
        return this.rokezzzApiService.apiUrl + this.apiPath + '/' + id;
    }

    public getCollection(
        name: string,
        apiFilterConfig: ApiFilterConfig,
        onSuccess: OnFinish<ApiResponse<Setting>>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.getCollection(
            this.apiPath,
            {
                name: name
            },
            apiFilterConfig,
            onSuccess,
            onError,
        );
    }

    public getCollectionAdmin(
        name: string,
        apiFilterConfig: ApiFilterConfig,
        onSuccess: OnFinish<ApiResponse<Setting>>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.getCollection(
            this.apiPath + '/byAdmin',
            {
                name: name
            },
            apiFilterConfig,
            onSuccess,
            onError,
        );
    }

    public patch(
        id: number,
        setting: Setting,
        onSuccess: OnFinish<void>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.patch(
            this.apiPath + '/' + id,
            setting,
            onSuccess,
            onError
        );
    }

    public get(
        id: number,
        onSuccess: OnFinish<ApiResponse<Setting>>,
        onError: OnFinish<HttpErrorResponse>
    ) {
        this.rokezzzApiService.get(
            this.apiPath + '/' + id,
            {},
            onSuccess,
            onError,
        );
    }
}
